<app-simple-responsive-frame>
    <div class="details">
        <div class="col-12 lg:col-12 md:col-12">
            <h2>Describe tu {{ segmentLabel?.toLowerCase() }}</h2>
            <span>Selecciona 3 etiquetas para destacar tu propiedad.</span>
        </div>

        <!-- Contenedor de etiquetas -->
        <div class="tag-container">
            <div
                *ngFor="let tag of tags"
                class="tag-item"
                [class.selected]="tag.selected"
                (click)="toggleTagSelection(tag)"
                [attr.aria-pressed]="tag.selected">
                <i class="pi pi-circle-on" style="font-size: 1.5rem;"></i>
                <span>{{ tag.tag }}</span>
            </div>
        </div>

        <!-- Mensaje de error -->
        <div class="error-message" *ngIf="showErrorDialog">
            <ul class="text-danger list-unstyled" style="list-style: none; padding: 0; margin: 0; margin-top: 5px">
                <li>
                    <p-message severity="error" [text]="dialogCode + ' ' + dialogMessage"></p-message>
                </li>
            </ul>
        </div>
    </div>

    <app-page-navigation-bar
        [value]="60"
        [type]="'complete'"
        [previousPageURL]="previousUrl"
        [nextPageURL]="nextUrl"
        [flowMode]="currentMode"
        [stepKey]="'tags'"
        (goNext)="handleNextStep()"
        (goPrevious)="handlePreviousStep()"
        (saveAndExit)="handleSaveAndExit()">
    </app-page-navigation-bar>
</app-simple-responsive-frame>
